<div class="project-component">

  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
    <div *ngIf="project">
      <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Policies for: {{project.name}}</h2>
    </div>

    <div style="display: flex; flex-direction: row; margin-top: 16px;align-items:center;">
      <button mat-raised-button
              style="border-radius: 6px;margin-right: 10px;white-space: nowrap; "
              class="button" [routerLink]="['/projects', 'project', projectId]">
        Back to project
      </button>
    </div>
  </div>

  <div style="display: flex; flex-direction: row;">
    <div style="flex:0 0 30%">
      <div style="max-height: calc(100vh - 290px); ">
        <div style="padding: 3px; cursor: pointer;"
             [ngStyle]="{ backgroundColor: selectedPolicy === policy ? '#AAAAAA' : '#FFFFFF' }"
             (click)="selectedPolicy = policy"
             *ngFor="let policy of policies">{{policy.name}}</div>
      </div>
    </div>
    <div style="flex:1 1 auto; padding-left: 10px;">
      <p-table [value]="remainingControlItems"
               *ngIf="projectControlItems && projectControlItems.length > 0"
               dataKey="projectControlItemId"
               scrollHeight="calc(100vh - 290px)"
               [scrollable]="true"
               [reorderableColumns]="true"
      >

        <ng-template pTemplate="header">
          <tr>
            <th>Control</th>
            <th style="width: 2em;"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
          <tr class="status-row"
              *ngIf="(!item.controlItem.parentControlItemId || expandedSmallItem[item.controlItem.parentControlItemId]) && (item.controlItem.parentControlItemId || (!item.subItems.length || project.displayParentRows && !project.isParentContainer))">
            <td [ngStyle]="{'padding-left': item.controlItem.parentControlItemId ? '25px' : '0.5em'}" (click)="switchItem($event, item)">
              <i
                [ngClass]="expandedSmallItem[item.controlItem.controlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"
                [ngStyle]="{'display': item.subItems && item.subItems.length ? 'inline-block' : 'none'}"
                (click)="expandedSmallItem[item.controlItem.controlItemId] = !expandedSmallItem[item.controlItem.controlItemId]; $event.stopPropagation(); $event.preventDefault();"></i>
              {{item.controlItem.complianceAreaControlId}}
            </td>
            <td (click)="switchItem($event, item)">
              <mat-checkbox readonly="readonly" [checked]="policyMap[item.projectControlItemId][selectedPolicy.id]"></mat-checkbox>
            </td>
          </tr>
          <tr
            *ngIf="item.subItems.length && !item.controlItem.parentControlItemId && project.isParentContainer && project.displayParentRows">
            <td [ngStyle]="{'padding-left': item.controlItem.parentControlItemId ? '20px' : '0.5em'}">
              <i *ngIf="item.subItems.length"
                 [ngClass]="expandedSmallItem[item.controlItem.controlItemId] ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"
                 [ngStyle]="{'display': item.subItems && item.subItems.length ? 'inline-block' : 'none'}"
                 (click)="expandedSmallItem[item.controlItem.controlItemId] = !expandedSmallItem[item.controlItem.controlItemId]; $event.stopPropagation(); $event.preventDefault();"></i>
              {{item.controlItem.complianceAreaControlId}}
            </td>
            <td>
              <mat-checkbox readonly="readonly" [checked]="policyMap[item.projectControlItemId][selectedPolicy.id]"></mat-checkbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
